import { m } from "@plannello/i18n/messages";
import { Skeleton } from "@/components/ui";

/**
 * Shown by the router while route guards resolve (session and setup checks) for longer than 150ms.
 * Same base tone as the shell and the first paint in index.html, so a slow API never shows a blank
 * page and a fast one shows nothing at all.
 */
export function BootScreen() {
  return (
    <div role="status" aria-busy="true" className="anim-fade flex min-h-dvh items-center justify-center bg-chrome">
      <span className="sr-only">{m.common_loading()}</span>
      <Skeleton className="size-8 rounded-control" />
    </div>
  );
}
